import { useState } from 'react';
import translations from '../../../../translations';
import { isNullOrEmpty } from '../../../../utils/guard';
import FormGroup from '../../../generic/FormGroup';
import DataActions from '../common/dataActions/DataActions';
import ListenerList from '../common/listeners/ListenerList';
import NameInput from '../common/NameInput';
import OutcomeList from '../common/outcomes/OutcomeList';
import { useMapElement } from '../contextProviders/MapElementProvider';
import ModalBody from '../../../generic/modal/ModalBody';
import ModalFooter from '../../../generic/modal/ModalFooter';
import Footer from '../common/Footer';

const LoadConfiguration = () => {
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const { mapElement, onUpdateName, onUpdateComments, onSaveMapElement, onClose } =
        useMapElement();

    if (!mapElement) {
        onClose();
        return;
    }

    const { developerName, developerSummary } = mapElement;

    const isLoadElementNameValid = !isNullOrEmpty(developerName);

    const onSave = () => {
        setHasSubmitted(true);
        if (isLoadElementNameValid) {
            onSaveMapElement(mapElement);
        }
    };

    return (
        <>
            <ModalBody>
                <NameInput
                    isValid={isLoadElementNameValid}
                    showValidation={hasSubmitted}
                    id="load-element-name"
                    name={mapElement.developerName}
                    onUpdateName={onUpdateName}
                />
                <DataActions />
                <OutcomeList />
                <ListenerList />
                <FormGroup
                    htmlFor="load-element-comments"
                    label="Comments about this Database Load"
                >
                    <textarea
                        id="load-element-comments"
                        className="form-control form-textarea"
                        value={developerSummary ?? ''}
                        onChange={(e) => onUpdateComments(e.target.value)}
                    />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Footer
                    save={onSave}
                    saveButtonText={translations.GRAPH_config_panel_save}
                    cancel={onClose}
                />
            </ModalFooter>
        </>
    );
};

export default LoadConfiguration;
